export const LogoMark = ({ className = "w-9 h-9" }) => (
  <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
    <defs>
      <linearGradient id="logoGrad" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0" stopColor="#A855F7" />
        <stop offset="0.55" stopColor="#7C3AED" />
        <stop offset="1" stopColor="#6B21A8" />
      </linearGradient>
    </defs>
    <rect x="2" y="2" width="60" height="60" rx="16" fill="url(#logoGrad)" />
    <rect x="4.5" y="4.5" width="55" height="55" rx="13.5" fill="none" stroke="#FFFFFF" strokeOpacity="0.35" strokeWidth="1.5" />
    <path d="M17 19 L32 37 L47 19" fill="none" stroke="#FFFFFF" strokeWidth="8" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M32 37 V47" stroke="#E9D5FF" strokeWidth="8" strokeLinecap="round" />
    <path d="M47 10 l1.9 4.4 4.4 1.9 -4.4 1.9 -1.9 4.4 -1.9 -4.4 -4.4 -1.9 4.4 -1.9 z" fill="#F0ABFC" />
  </svg>
);

const Logo = ({ compact = false }) => (
  <span className="flex items-center gap-2.5">
    <LogoMark />
    {!compact && (
      <span className="leading-none hidden sm:block">
        <span className="block font-display font-extrabold text-lg tracking-tight"><span className="brand-shine">Y.E.S.</span></span>
        <span className="block font-mono text-[9px] uppercase tracking-[0.22em] text-slate-500 mt-0.5 hidden sm:block">
          Youth Empowerment &amp; Support
        </span>
      </span>
    )}
  </span>
);

export default Logo;